import React from "react";
import styled from "styled-components";
import { defineMessages, injectIntl } from "react-intl";
import { FormattedMessage } from "components/FormattedMessage";

const messages = defineMessages({
  error_text: {
    id: "shared.DownloadSMSForm.FormStateMessage.sms_error_text",
    defaultMessage:
      "There was an issue sending SMS; please check number or try again later.",
  },
  loading_text: {
    id: "shared.DownloadSMSForm.FormStateMessage.loading_text",
    defaultMessage: "Sending...",
  },
  successful_text: {
    id: "shared.DownloadSMSForm.FormStateMessage.successful_text",
    defaultMessage:
      "Sent! Check your mobile device for a link to download the app.",
  },
});

const FormStatus_ = ({ isLoading, isSuccessful, hasError }) => {
  if (!isLoading && !isSuccessful && !hasError) {
    return null;
  }

  let message;
  if (hasError) {
    message = messages.error_text;
  } else if (isLoading) {
    message = messages.loading_text;
  } else if (isSuccessful) {
    message = messages.successful_text;
  } else {
    throw Error(
      "Developer error: Case checking was not exhaustive in FormStatus component."
    );
  }

  return (
    <StyledFormStatus hasError={hasError}>
      <FormattedMessage message={message} />
    </StyledFormStatus>
  );
};

const StyledFormStatus = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${(props) => props.theme.spacing.md};
  color: ${({ hasError, theme }) =>
    hasError ? theme.color.errorText : theme.color.bodyText};
`;

export const FormStatus = injectIntl(FormStatus_);
